import React from 'react';
import PropTypes from 'prop-types';
import { Badge, FlexContainer, TextOverflow, Typography, Cushion } from '@pitchero/react-ui';
import NotificationBadge from '../notification-badge';

const WebsiteListItem = ({ website: { colours, name }, badgeTotal }) => (
  <Cushion bottom="medium" className="network-panel-list-item">
    <FlexContainer alignItems="center">
      <div style={{ width: 26, flexShrink: 0, marginRight: 18, lineHeight: 0 }}>
        <Badge primary={colours.primary} secondary={colours.secondary} size={26} />
      </div>
      <TextOverflow maxWidth="100%">
        <Typography preset="subtitle--small" color="#666">
          {name}
        </Typography>
      </TextOverflow>
      {badgeTotal > 0 && <NotificationBadge total={badgeTotal} style={{ marginLeft: 6 }} />}
    </FlexContainer>
  </Cushion>
);

WebsiteListItem.defaultProps = {
  badgeTotal: 0,
};

WebsiteListItem.propTypes = {
  website: PropTypes.shape({
    colours: PropTypes.shape({
      primary: PropTypes.string,
      secondary: PropTypes.string,
    }),
    name: PropTypes.string,
  }).isRequired,
  badgeTotal: PropTypes.number,
};

export default WebsiteListItem;
